var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardArrow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.899,
    height: 23.799,
    viewBox: "0 0 11.899 23.799",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_8",
    "data-name": "Subtraction 8",
    d: "M11.9,23.8h0a1.987,1.987,0,0,1-1.414-.586l-9.9-9.9a2,2,0,0,1,0-2.829l9.9-9.9A1.987,1.987,0,0,1,11.9,0V23.8Z",
    transform: "translate(11.9 23.799) rotate(180)",
    fill: "#eff4f7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardArrow2);
export default __webpack_public_path__ + "static/media/ForwardArrow2.c53fa906887fbe92ef20d25ad01ff469.svg";
export { ForwardRef as ReactComponent };